/* eslint-disable @typescript-eslint/ban-types */
import { AxiosRequestHeaders, AxiosResponse } from 'axios'

export function buildMockResponse(
  data?: object,
  status = 200,
  statusText = 'OK',
  headers: Record<string, string> = {},
  config: object = {},
  request: object = {}
): AxiosResponse {
  return {
    data: data,
    status: status,
    statusText: statusText,
    headers: headers,
    config: {
      headers: {} as AxiosRequestHeaders,
      ...config
    },
    request: request
  }
}
